require('../scheduleService');
require('../../fhApp/currentPlatform/currentPlatformDetailService');

'use strict';

angular.module('app.schedule.scheduleSearch.scheduleSearchService', [
  'app.schedule.scheduleService',
  'app.currentPlatform.currentPlatformDetailService'
])
  .factory('app.schedule.scheduleSearch.scheduleSearchService', [
    '$http', '$q', '$rootScope', 'app.schedule.scheduleService', 'app.currentPlatform.currentPlatformDetailService',
    function ($http, $q, $rootScope, scheduleService, currentPlatformDetails) {
      let service = {
        last_search: {},
        scheduleSearch: {
          initialized: false,
          term: null,
          date_offset: null,
          custom_date: null,
          use_custom_date: true,
          use_current_time: true,
          show_custom_date_selector: false,
          date_disabled: false,
          custom_date_title: '',
          userSelected: false,
          searcher: {
            teams: null,
            leagues: null,
            events: null
          },
          results: {
            teams: null,
            leagues: null,
            events: null
          },
          schedule_params: null,
          toggleShowDateSelector: function () {
            service.scheduleSearch.use_custom_date = true;
            service.scheduleSearch.show_custom_date_selector = !service.scheduleSearch.show_custom_date_selector;
          },
          openCustomDateSelector: function () {
            service.scheduleSearch.custom_date.start = moment();
            service.scheduleSearch.custom_date.end = moment();
            service.scheduleSearch.toggleShowDateSelector();
          },
          selectAllUpcomingGames: function () {
            service.scheduleSearch.set_custom_date(moment(), null);
            service.scheduleSearch.toggleShowDateSelector();
          },
          selectAllPastGames: function () {
            service.scheduleSearch.set_custom_date(null, moment());
            service.scheduleSearch.toggleShowDateSelector();
          },
          get_date: function () {
            let date;

            if (service.scheduleSearch.use_custom_date) {
              date = service.scheduleSearch.custom_date;
            } else {
              date = service.scheduleSearch.calc_date();
            }

            if (moment.isMoment(date)) {
              date = date.toDate();
            }

            return date;
          },
          search_terms: function (groups) {
            if (service.scheduleSearch.initialized) {

              let ref = service.scheduleSearch.searcher;
              let results = [];
              for (let group in ref) {
                if (ref.hasOwnProperty(group)) {
                  if (Array.isArray(groups)) {
                    if (groups.indexOf(group) === -1) {
                      continue;
                    }
                  }

                  let params = {
                    term: service.scheduleSearch.term,
                    group: group,
                    platform_leagues: currentPlatformDetails.platform.strleague_nicknames
                      ? currentPlatformDetails.platform.strleague_nicknames.toString()
                      : null, //assign platform leagues as a search param
                  };
                  results.push(service.scheduleSearch.send_search_terms_request(group, params));
                }
              }

              return results;
            }
          },
          clearResults: function () {
            service.scheduleSearch.results = {
              teams: null,
              leagues: null,
              events: null
            };
          },
          send_search_terms_request: function (group, params) {
            let promise;
            if (service.scheduleSearch.searcher[group]) {
              service.scheduleSearch.searcher[group].resolve();
            }
            service.scheduleSearch.searcher[group] = $q.defer();
            promise = service.scheduleSearch.searcher[group].promise;

            return $http.get(window.location.api('/schedule/search_terms'), {
              timeout: promise,
              params: params
            })
              .then(
                (response) => {
                  let data = response.data;

                  if (data && data.results) {
                    if (typeof data.results.teams !== 'undefined') {
                      service.scheduleSearch.results.teams = data.results.teams;
                    }
                    if (typeof data.results.leagues !== 'undefined') {
                      service.scheduleSearch.results.leagues = data.results.leagues;
                    }
                    if (typeof data.results.events !== 'undefined') {
                      service.scheduleSearch.results.events = data.results.events;
                    }
                  }
                  return service.scheduleSearch.searcher[group] = null;
                },
                () => {
                  return service.scheduleSearch.searcher[group] = null;
                }
              );
          },
          set_custom_date_text: function (title) {

            if (typeof title === 'undefined') {
              if (typeof service.scheduleSearch.custom_date !== 'undefined') {
                if (service.scheduleSearch.custom_date.start && !service.scheduleSearch.custom_date.end) {
                  service.scheduleSearch.custom_date_title = 'All Upcoming Games';
                }
                else if (!service.scheduleSearch.custom_date.start && service.scheduleSearch.custom_date.end) {
                  service.scheduleSearch.custom_date_title = 'All Past Games';
                }
                else {
                  let dateTitle;
                  if (moment(service.scheduleSearch.custom_date.start).isSame(moment(service.scheduleSearch.custom_date.end), 'day')) {
                    dateTitle = moment(service.scheduleSearch.custom_date.start).format('dddd MMMM D, YYYY');
                  }
                  else {
                    dateTitle = moment(service.scheduleSearch.custom_date.start).format('ddd. MMMM D, YYYY') + ' - ' + moment(service.scheduleSearch.custom_date.end).format('ddd. MMMM D, YYYY');
                  }
                  service.scheduleSearch.custom_date_title = dateTitle;
                }
              }

            }
            else {
              service.scheduleSearch.custom_date_title = title;
            }
          },
          set_custom_date_sort_direction: function (title) {
            service.scheduleSearch.schedule_params.status = null;
            if (typeof title === 'undefined' && service.scheduleSearch.custom_date) {
              if (service.scheduleSearch.custom_date.start && !service.scheduleSearch.custom_date.end) {
                service.scheduleSearch.schedule_params.sort = 'asc';
              }
              else if (!service.scheduleSearch.custom_date.start && service.scheduleSearch.custom_date.end) {
                service.scheduleSearch.schedule_params.status = 'vod';
                service.scheduleSearch.schedule_params.sort = 'desc';
              }
            }
          },
          set_custom_date: function (start_date, end_date, title) {
            if (service.scheduleSearch.custom_date) {
              service.scheduleSearch.custom_date.start = start_date;
              service.scheduleSearch.custom_date.end = end_date;
              service.scheduleSearch.use_custom_date = true;

              service.scheduleSearch.set_custom_date_text(title);
              service.scheduleSearch.set_custom_date_sort_direction(title);
            }
          },
          calc_date: function () {
            let offset;
            offset = service.scheduleSearch.date_offset;
            if (!offset) {
              offset = {};
            }
            if (!offset.start) {
              offset.start = 0;
            }
            if (!offset.end) {
              offset.end = 0;
            }
            return {
              start: moment().add(offset.start, 'days').toDate(),
              end: moment().add(offset.end, 'days').toDate()
            };
          },
          set_date_offset: function (offset) {
            if (!offset) {
              offset = {};
            }
            if (!offset.start) {
              offset.start = 0;
            }
            if (!offset.end) {
              offset.end = 0;
            }
            service.scheduleSearch.use_custom_date = false;
            return service.scheduleSearch.date_offset = offset;
          },
          active_offset: function () {
            if (service.scheduleSearch.date_offset) {
              if (service.scheduleSearch.date_offset.start === -30 && service.scheduleSearch.date_offset.end === 0) {
                return '-30';
              }
              if (service.scheduleSearch.date_offset.start === -7 && service.scheduleSearch.date_offset.end === 0) {
                return '-7';
              }
              if (service.scheduleSearch.date_offset.start === 0 && service.scheduleSearch.date_offset.end === 0) {
                return 'today';
              }
              if (service.scheduleSearch.date_offset.start === 0 && service.scheduleSearch.date_offset.end === 7) {
                return '+7';
              }
              if (service.scheduleSearch.date_offset.start === 0 && service.scheduleSearch.date_offset.end === 30) {
                return '+30';
              }
            }
            return 'custom';
          },
          is_active_offset: function (name) {
            return service.scheduleSearch.active_offset() === name;
          },
          evaluate_date: function (range) {
            let end, format_str, g30, g7, l30, l7, start, today;
            if (!range) {
              return false;
            }
            if (!range.start) {
              return false;
            }
            if (!range.end) {
              return false;
            }
            start = range.start;
            end = range.end;
            format_str = 'YYYY-MM-DD';
            if (!moment.isMoment(start)) {
              if (!moment.isDate(start)) {
                start = new Date(start);
              }
              start = moment(start);
            }
            start = start.format(format_str);
            if (!moment.isMoment(end)) {
              if (!moment.isDate(end)) {
                end = new Date(end);
              }
              end = moment(end);
            }
            end = end.format(format_str);
            today = moment().format(format_str);
            l30 = moment().subtract(30, 'days').format(format_str);
            l7 = moment().subtract(7, 'days').format(format_str);
            g7 = moment().add(7, 'days').format(format_str);
            g30 = moment().add(30, 'days').format(format_str);
            if (start === l30 && end === today) {
              return '-30';
            }
            if (start === l7 && end === today) {
              return '-7';
            }
            if (start === today && end === today) {
              return 'today';
            }
            if (start === today && end === g7) {
              return '+7';
            }
            if (start === today && end === g30) {
              return '+30';
            }
            return 'custom';
          },
          clear_term: function () {
            service.scheduleSearch.term = null;
            if (service.scheduleSearch.schedule_params) {
              service.scheduleSearch.schedule_params.search_id = null;
              service.scheduleSearch.schedule_params.type = null;
              service.scheduleSearch.schedule_params.search_term =null;
            }
            service.scheduleSearch.clearResults();
          },
          set_term: function (type, search_id, search_term) {
            if (service.scheduleSearch.schedule_params) {
              service.scheduleSearch.schedule_params.search_id = search_id;
              service.scheduleSearch.schedule_params.type = type;
              service.scheduleSearch.schedule_params.search_term = search_term;
            }
          },
          search_schedule: function (sort_direction, last_search_name) {
            if (scheduleService.schedule) {
              service.scheduleSearch.use_custom_date = true;

              if (service.scheduleSearch.initialized) {
                let date = service.scheduleSearch.get_date();
                service.scheduleSearch.schedule_params.start_date = date.start;
                service.scheduleSearch.schedule_params.end_date = date.end;

                if (sort_direction) {
                  service.scheduleSearch.schedule_params.sort = sort_direction;
                }
                service.scheduleSearch.schedule_params.date_disabled = service.scheduleSearch.date_disabled;
                service.scheduleSearch.schedule_params.use_current_time = service.scheduleSearch.use_current_time;

                return scheduleService.schedule.retrieve(service.scheduleSearch.schedule_params, {saveToHistory: true})
                  .then(function () {
                    if (last_search_name) {
                      service.last_search[last_search_name] = {
                        term: service.scheduleSearch.term,
                        date_offset: service.scheduleSearch.date_offset,
                        custom_date: service.scheduleSearch.custom_date,
                        schedule_params: service.scheduleSearch.schedule_params
                      };
                    }

                    if (scheduleService.schedule.current_params) {
                      service.scheduleSearch.schedule_params = angular.copy(scheduleService.schedule.current_params);
                      service.scheduleSearch.set_custom_date(service.scheduleSearch.schedule_params.start_date, service.scheduleSearch.schedule_params.end_date);
                      service.scheduleSearch.use_custom_date = true;
                    }
                  });
              }
            }
          },
          init: function (last_search_name) {
            if (last_search_name && service.last_search[last_search_name]) {
              let last_search = service.last_search[last_search_name];

              service.scheduleSearch.term = last_search.term;
              service.scheduleSearch.date_offset = last_search.date_offset;
              service.scheduleSearch.custom_date = last_search.custom_date;
              service.scheduleSearch.schedule_params = angular.copy(last_search.schedule_params);
            } else {
              service.scheduleSearch.date_offset = {
                start: 0,
                end: 0
              };
              if (scheduleService.schedule.current_params) {
                service.scheduleSearch.custom_date = {
                  start: scheduleService.schedule.current_params.start_date,
                  end: scheduleService.schedule.current_params.end_date
                };
              } else {
                service.scheduleSearch.custom_date = {
                  start: null,
                  end: null
                };
              }

              service.scheduleSearch.schedule_params = scheduleService.schedule.current_params ?
                                                       angular.copy(scheduleService.schedule.current_params):
                                                        angular.copy(scheduleService.schedule.default_params);

              service.scheduleSearch.term = service.scheduleSearch.schedule_params &&
                                            service.scheduleSearch.schedule_params.search_term ?
                                            service.scheduleSearch.schedule_params.search_term :
                                            null;
            }

            service.scheduleSearch.initialized = true;
            $rootScope.$broadcast('assign_schedule_search_group');
          }
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/scheduleSearch/scheduleSearchService.js